import { ViewContainerRef } from '@angular/core';

import { IBaseMarkerOptions } from './base-marker-options';

export interface IGoogleMapComponentMarkerOptions extends IBaseMarkerOptions {
  data?: any;
  viewContainerRef?: ViewContainerRef;
}
